<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex
        md12
        lg12>
        <material-card
          color="general"
          title="Lead Website"
          text="Lead dari chatbot website, input manual, dan sheet lama">

          <v-layout
            row
            wrap>
            <v-flex
              xs12
              class="pb-0">
              <v-chip
                v-for="(jml, st) in ringkasan"
                :key="st"
                :color="warnaStatus(st)"
                :outline="searchBy.status !== st"
                text-color="white"
                small
                @click="searchBy.status = searchBy.status === st ? '' : st">
                <span :class="searchBy.status !== st ? 'grey--text text--darken-3' : ''">{{ st }} · {{ jml }}</span>
              </v-chip>
            </v-flex>
            <v-flex
              xs12
              sm6
              md4>
              <v-text-field
                v-model="search"
                class="pl-2 pr-2"
                prepend-icon="search"
                placeholder="Cari nama / perusahaan / kota / kontak"
                clearable
                single-line
                hide-details/>
            </v-flex>
            <v-flex
              xs12
              sm6
              md4>
              <v-select
                v-model="searchBy.kebutuhan"
                :items="kebutuhanList"
                class="pl-2 pr-2"
                label="Kebutuhan"
                clearable
                hide-details/>
            </v-flex>
            <v-flex
              xs12
              md4
              class="text-xs-right">
              <v-btn
                color="general"
                dark
                @click="bukaForm(null)">
                <v-icon left>add</v-icon>Tambah Lead
              </v-btn>
            </v-flex>
          </v-layout>

          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="DataList"
            :pagination.sync="pagination"
            :rows-per-page-items="[25, 50, 100]"
            :total-items="totalRows"
            dense
            class="elevation-1">
            <template v-slot:items="props">
              <tr
                style="cursor: pointer"
                @click="buka(props.item)">
                <td>{{ tgl(props.item.waktu) }}</td>
                <td>
                  <v-chip
                    :color="warnaStatus(props.item.status)"
                    text-color="white"
                    small>{{ props.item.status }}</v-chip>
                </td>
                <td>{{ props.item.kebutuhan }}</td>
                <td><b>{{ props.item.perusahaan }}</b></td>
                <td>{{ props.item.nama }}</td>
                <td>{{ props.item.kontak }}<div class="caption grey--text">{{ props.item.email }}</div></td>
                <td>{{ props.item.pic || '-' }}</td>
                <td>
                  <span v-if="props.item.lastFollowUpBy">{{ props.item.lastFollowUpBy }}
                    <div class="caption grey--text">{{ tgl(props.item.lastFollowUpAt) }}</div>
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <v-chip
                    small
                    outline>{{ labelSumber(props.item.sumber) }}</v-chip>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="text-xs-center pa-3">Belum ada lead.</div>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      max-width="760px"
      scrollable>
      <v-card v-if="item">
        <v-card-title class="general white--text">
          <div>
            <div class="headline">{{ item.perusahaan }}</div>
            <div>{{ item.nama }} · {{ item.kebutuhan }} · {{ tgl(item.waktu) }}</div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-layout
            row
            wrap>
            <v-flex
              xs12
              sm6>
              <div class="caption grey--text">Kontak</div>
              <div class="subheading">
                {{ item.kontak }}
                <v-btn
                  v-if="waLink(item.kontak)"
                  :href="waLink(item.kontak)"
                  target="_blank"
                  color="green"
                  dark
                  small>WhatsApp</v-btn>
                <v-btn
                  v-else-if="item.kontak && item.kontak.indexOf('@') > 0"
                  :href="'mailto:' + item.kontak"
                  color="general"
                  dark
                  small>Email</v-btn>
              </div>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <div class="caption grey--text">Kota · Sumber</div>
              <div>{{ item.kota || '-' }} · {{ labelSumber(item.sumber) }}<span v-if="item.halaman"> ({{ item.halaman }})</span></div>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <div class="caption grey--text">Email</div>
              <div>{{ item.email || '-' }}</div>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <div class="caption grey--text">PIC OIS</div>
              <div>{{ item.pic || '-' }}</div>
            </v-flex>
          </v-layout>
          <v-chip
            v-if="item.customerId"
            color="green"
            text-color="white"
            small
            class="ml-0">
            <v-icon
              left
              small>check</v-icon>Sudah tercatat sebagai Customer di Master Data
          </v-chip>
          <div
            v-if="item.sumber && item.sumber !== 'WEBSITE' && item.kebutuhan"
            class="mt-2">
            <div class="caption grey--text">Kebutuhan</div>
            <div style="white-space: pre-line">{{ item.kebutuhan }}</div>
          </div>
          <div
            v-if="item.rekomendasi"
            class="mt-2">
            <div class="caption grey--text">Rekomendasi</div>
            <div style="white-space: pre-line">{{ item.rekomendasi }}</div>
          </div>

          <v-divider class="my-3"/>
          <div
            v-for="(j, i) in item.jawaban"
            :key="i"
            class="mb-2">
            <div class="caption grey--text">{{ j.q }}</div>
            <div>{{ j.a }}</div>
          </div>
          <div
            v-if="item.catatan"
            class="mb-2">
            <div class="caption grey--text">Catatan</div>
            <div style="white-space: pre-line">{{ item.catatan }}</div>
          </div>

          <div v-if="fotoUrls.length">
            <div class="caption grey--text">Foto</div>
            <a
              v-for="(u, i) in fotoUrls"
              :key="i"
              :href="u"
              target="_blank">
              <img
                :src="u"
                style="width: 150px; border-radius: 6px; margin: 4px">
            </a>
          </div>

          <v-divider class="my-3"/>
          <div class="title mb-2">Follow-up</div>
          <div
            v-if="!item.followUp || !item.followUp.length"
            class="grey--text mb-2">Belum ada follow-up.</div>
          <div
            v-for="(f, i) in item.followUp"
            :key="'f' + i"
            class="mb-2">
            <div class="caption grey--text">{{ tgl(f.waktu) }} · {{ f.user }} ·
              <v-chip
                :color="warnaStatus(f.status)"
                text-color="white"
                small>{{ f.status }}</v-chip>
            </div>
            <div style="white-space: pre-line">{{ f.teks }}</div>
          </div>

          <v-layout
            row
            wrap>
            <v-flex
              xs12
              sm4>
              <v-select
                v-model="fu.status"
                :items="statusList"
                label="Status"/>
            </v-flex>
            <v-flex
              xs12
              sm8>
              <v-textarea
                v-model="fu.teks"
                label="Catatan follow-up"
                rows="2"
                auto-grow/>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            flat
            color="general"
            @click="bukaForm(item)">
            <v-icon left>edit</v-icon>Edit data
          </v-btn>
          <v-btn
            v-if="!item.customerId && hasPermission('MA_MASTER_DATA')"
            flat
            color="green"
            @click="bukaCustomer(item)">
            <v-icon left>person_add</v-icon>Jadikan Customer
          </v-btn>
          <v-spacer/>
          <v-btn
            flat
            @click="dialog = false">Tutup</v-btn>
          <v-btn
            :loading="menyimpan"
            color="general"
            dark
            @click="simpanFollowUp">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogForm"
      max-width="640px"
      persistent>
      <v-card>
        <v-card-title class="general white--text headline">{{ form.id ? 'Edit Lead' : 'Tambah Lead' }}</v-card-title>
        <v-card-text>
          <v-layout
            row
            wrap>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="form.perusahaan"
                label="Perusahaan"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="form.nama"
                label="Nama"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="form.kontak"
                label="No HP / WA"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="form.email"
                label="Email"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="form.kota"
                label="Kota"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="form.pic"
                label="PIC OIS"/>
            </v-flex>
            <v-flex xs12>
              <v-combobox
                v-model="form.kebutuhan"
                :items="kebutuhanList"
                label="Kebutuhan (pilih atau ketik)"/>
            </v-flex>
            <v-flex
              v-if="!form.id"
              xs12
              sm6>
              <v-select
                v-model="form.status"
                :items="statusList"
                label="Status awal"/>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="form.rekomendasi"
                label="Rekomendasi"
                rows="2"
                auto-grow/>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="form.catatan"
                label="Catatan"
                rows="2"
                auto-grow/>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            flat
            @click="dialogForm = false">Batal</v-btn>
          <v-btn
            :loading="menyimpan"
            color="general"
            dark
            @click="simpanForm">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCustomer"
      max-width="600px"
      persistent>
      <v-card>
        <v-card-title class="green white--text headline">Jadikan Customer</v-card-title>
        <v-card-text>
          <div class="caption grey--text mb-2">
            Pilih company yang sudah ada di Master Data supaya tidak dobel. Kalau belum ada, kosongkan pilihan dan isi nama company baru.
          </div>
          <v-autocomplete
            v-model="cust.companyId"
            :items="companyHasil"
            :search-input.sync="cariCompany"
            :loading="loadingCompany"
            item-text="name"
            item-value="id"
            label="Cari company di Master Data"
            no-filter
            clearable
            hide-no-data/>
          <v-text-field
            v-if="!cust.companyId"
            v-model="cust.companyNama"
            label="Nama company baru"/>
          <v-layout
            v-if="!cust.companyId"
            row
            wrap>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="cust.companyPhone"
                label="Telepon company"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="cust.industry"
                label="Industri"/>
            </v-flex>
          </v-layout>
          <v-divider class="my-2"/>
          <v-layout
            row
            wrap>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="cust.nama"
                label="Nama customer"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="cust.position"
                label="Jabatan"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="cust.mobilePhone"
                label="HP / WA"/>
            </v-flex>
            <v-flex
              xs12
              sm6>
              <v-text-field
                v-model="cust.email"
                label="Email"/>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            flat
            @click="dialogCustomer = false">Batal</v-btn>
          <v-btn
            :loading="menyimpan"
            color="green"
            dark
            @click="simpanCustomer">Simpan ke Master Data</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :color="snackColor"
      top>{{ snackText }}</v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  const STATUS = ['BARU', 'DIHUBUNGI', 'PENAWARAN', 'DEAL', 'SELESAI', 'BATAL']
  const FORM_KOSONG = { id: null, perusahaan: '', nama: '', kontak: '', email: '', kota: '', pic: '', kebutuhan: '', status: 'BARU', rekomendasi: '', catatan: '' }

  export default {
    name: 'LeadWebsite',
    data: () => ({
      loading: false,
      DataList: [],
      totalRows: 0,
      pagination: { rowsPerPage: 25 },
      search: '',
      searchBy: { status: '', kebutuhan: '' },
      ringkasan: {},
      statusList: STATUS,
      kebutuhanList: ['Machine Vision / Kamera Inspeksi', 'Barcode / OCR', 'OEE Monitoring', 'kWh Meter / Monitoring Energi', 'Lainnya'],
      headers: [
        { text: 'Waktu', value: 'waktu', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Kebutuhan', value: 'kebutuhan', sortable: false },
        { text: 'Perusahaan', value: 'perusahaan', sortable: false },
        { text: 'Nama', value: 'nama', sortable: false },
        { text: 'Kontak', value: 'kontak', sortable: false },
        { text: 'PIC', value: 'pic', sortable: false },
        { text: 'Follow-up terakhir', value: 'lastFollowUpBy', sortable: false },
        { text: 'Sumber', value: 'sumber', sortable: false }
      ],
      dialog: false,
      dialogForm: false,
      dialogCustomer: false,
      cust: {},
      companyHasil: [],
      cariCompany: null,
      loadingCompany: false,
      timerCompany: null,
      form: { ...FORM_KOSONG },
      item: null,
      fotoUrls: [],
      fu: { status: '', teks: '' },
      menyimpan: false,
      snackbar: false,
      snackText: '',
      snackColor: 'success',
      timer: null
    }),
    computed: {
      ...mapGetters(['hasPermission'])
    },
    watch: {
      cariCompany (q) {
        clearTimeout(this.timerCompany)
        if (!q || q.length < 2) return
        this.timerCompany = setTimeout(() => {
          this.loadingCompany = true
          this.$http.get('/api/leads/company-cari?q=' + encodeURIComponent(q))
            .then(r => { this.companyHasil = r.data })
            .catch(() => {})
            .finally(() => { this.loadingCompany = false })
        }, 300)
      },
      pagination: { handler () { this.muat() }, deep: true },
      'searchBy.status' () { this.halamanAwal() },
      'searchBy.kebutuhan' () { this.halamanAwal() },
      search () {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.halamanAwal(), 400)
      },
      dialog (v) {
        if (!v) this.lepasFoto()
      }
    },
    created () {
      this.muatRingkasan()
    },
    methods: {
      halamanAwal () {
        if (this.pagination.page !== 1) this.pagination.page = 1
        else this.muat()
      },
      muat () {
        const { page, rowsPerPage } = this.pagination
        const q = encodeURIComponent(this.search || '')
        const kb = encodeURIComponent(this.searchBy.kebutuhan || '')
        this.loading = true
        this.$http.get(`/api/leads?ps=${rowsPerPage || 25}&pn=${(page || 1) - 1}&qst=${this.searchBy.status}&qkb=${kb}&q=${q}`)
          .then(r => {
            this.DataList = r.data.content
            this.totalRows = r.data.totalElements
          })
          .catch(() => this.pesan('Gagal memuat lead', 'error'))
          .finally(() => { this.loading = false })
      },
      muatRingkasan () {
        this.$http.get('/api/leads/ringkasan').then(r => { this.ringkasan = r.data }).catch(() => {})
      },
      buka (row) {
        this.item = row
        this.fu = { status: row.status, teks: '' }
        this.dialog = true
        this.lepasFoto()
        // Foto butuh header Authorization, jadi diambil lewat axios lalu ditampilkan sebagai blob.
        for (let i = 1; i <= (row.jumlahFoto || 0); i++) {
          this.$http.get(`/api/leads/${row.id}/foto/${i}`, { responseType: 'blob' })
            .then(r => this.fotoUrls.push(URL.createObjectURL(r.data)))
            .catch(() => {})
        }
      },
      lepasFoto () {
        this.fotoUrls.forEach(u => URL.revokeObjectURL(u))
        this.fotoUrls = []
      },
      bukaForm (lead) {
        this.form = lead ? { ...FORM_KOSONG, ...lead } : { ...FORM_KOSONG }
        this.dialogForm = true
      },
      simpanForm () {
        if (!this.form.perusahaan && !this.form.nama) {
          this.pesan('Isi minimal nama atau perusahaan', 'warning')
          return
        }
        this.menyimpan = true
        const req = this.form.id
          ? this.$http.put('/api/leads/' + this.form.id, this.form)
          : this.$http.post('/api/leads', this.form)
        req.then(r => {
          this.dialogForm = false
          if (this.item && this.item.id === r.data.id) this.item = r.data
          this.muat()
          this.muatRingkasan()
          this.pesan('Lead tersimpan', 'success')
        })
          .catch(() => this.pesan('Gagal menyimpan', 'error'))
          .finally(() => { this.menyimpan = false })
      },
      bukaCustomer (lead) {
        this.cust = {
          companyId: null,
          companyNama: lead.perusahaan || '',
          companyPhone: '',
          industry: '',
          nama: lead.nama || '',
          position: '',
          mobilePhone: lead.kontak || '',
          email: lead.email || ''
        }
        this.companyHasil = []
        this.cariCompany = lead.perusahaan || null
        this.dialogCustomer = true
      },
      simpanCustomer () {
        if (!this.cust.companyId && !this.cust.companyNama) {
          this.pesan('Pilih company atau isi nama company baru', 'warning')
          return
        }
        if (!this.cust.nama) {
          this.pesan('Nama customer wajib diisi', 'warning')
          return
        }
        this.menyimpan = true
        this.$http.post('/api/leads/' + this.item.id + '/jadikan-customer', this.cust)
          .then(r => {
            this.item = r.data
            const idx = this.DataList.findIndex(d => d.id === r.data.id)
            if (idx >= 0) this.$set(this.DataList, idx, r.data)
            this.dialogCustomer = false
            this.pesan('Tersimpan di Master Data Customer', 'success')
          })
          .catch(e => this.pesan((e.response && e.response.data && e.response.data.details) || 'Gagal menyimpan', 'error'))
          .finally(() => { this.menyimpan = false })
      },
      labelSumber (s) {
        return { MANUAL: 'Manual', SHEET: 'Sheet' }[s] || 'Website'
      },
      simpanFollowUp () {
        if (!this.fu.teks && this.fu.status === this.item.status) {
          this.pesan('Isi catatan atau ubah status', 'warning')
          return
        }
        this.menyimpan = true
        this.$http.post(`/api/leads/${this.item.id}/followup`, this.fu)
          .then(r => {
            this.item = r.data
            const idx = this.DataList.findIndex(d => d.id === r.data.id)
            if (idx >= 0) this.$set(this.DataList, idx, r.data)
            this.fu.teks = ''
            this.muatRingkasan()
            this.pesan('Follow-up tersimpan', 'success')
          })
          .catch(() => this.pesan('Gagal menyimpan', 'error'))
          .finally(() => { this.menyimpan = false })
      },
      waLink (kontak) {
        const d = (kontak || '').replace(/\D/g, '')
        if (kontak && kontak.indexOf('@') > 0) return ''
        if (d.length < 9) return ''
        return 'https://wa.me/' + (d.startsWith('0') ? '62' + d.slice(1) : d)
      },
      tgl (v) {
        return v ? new Date(v).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' }) : '-'
      },
      warnaStatus (s) {
        return { BARU: 'blue', DIHUBUNGI: 'orange', PENAWARAN: 'purple', DEAL: 'green', SELESAI: 'teal', BATAL: 'grey' }[s] || 'grey'
      },
      pesan (t, c) {
        this.snackText = t
        this.snackColor = c
        this.snackbar = true
      }
    }
  }
</script>
